<template>
  <v-app id="inspire" class="bodyPadding">
    <mo-header></mo-header>
    <v-content>
		<process-head></process-head>
		<process-list></process-list>
    </v-content>
  </v-app>
</template>

<script>

	import ProcessHead from './Header.vue';
	import ProcessList from './List.vue';

	export default {
		data () {
			return {

			}
		},
		components: {
			ProcessHead,
			ProcessList
		}
	}
</script>

<style scoped>
	@import '../shared/assets/css/shared.css'
</style>
